export default __webpack_public_path__ + "static/media/not-available.e3925385.png";